declare const jQuery: any;
const $ = jQuery;
const $window = $(window);

type JQuery = any;

export function initCustomCheckboxes(): void
{
	$("[data-custom-checkbox]").each(function () {
		initCustomCheckbox(this);
	});
}

export function initCustomCheckbox($origCheckbox, insertAfterOriginalInput = true): JQuery
{
	$origCheckbox = $($origCheckbox);
	if (!$origCheckbox[0] || $origCheckbox[0]._iw_checkbox_inited)
	{
		return;
	}
	$origCheckbox[0]._iw_checkbox_inited = true;
	const $customCheckbox = $(`<span class="custom-checkbox"><span></span></span>`);
	const checkedClass = "custom-checkbox-checked";
	const checkboxId: string = $origCheckbox.attr("id");
	const $label = $origCheckbox.closest("label").add(checkboxId ? $(`label[for="${checkboxId}"]`) : undefined);
	const defaultChecked: boolean = $origCheckbox.prop("checked");
	if (defaultChecked)
	{
		$customCheckbox.addClass(checkedClass);
	}

	function check(): void
	{
		if (!$origCheckbox.prop("checked"))
		{
			$origCheckbox.prop("checked", true).trigger("change");
		}
	}

	function uncheck(): void
	{
		if ($origCheckbox.prop("checked"))
		{
			$origCheckbox.prop("checked", false).trigger("change");
		}
	}

	function toggle(): void
	{
		if ($origCheckbox.prop("checked"))
		{
			uncheck();
		}
		else
		{
			check();
		}
	}

	const onChange = () => {
		if ($origCheckbox.prop("checked"))
		{
			$customCheckbox.addClass(checkedClass);
		}
		else
		{
			$customCheckbox.removeClass(checkedClass);
		}
	};

	$origCheckbox.on("change", onChange);

	$origCheckbox.closest("form").on("reset", (event) => {
		setTimeout(onChange, 80);
	});

	$origCheckbox.css({ display: "none" });

	$customCheckbox.add($label).on("click", (event) => {
		event.stopPropagation();
		toggle();
	});

	if (insertAfterOriginalInput)
	{
		$customCheckbox.insertAfter($origCheckbox);
	}

	return $customCheckbox;
}

if (!window["iw"])
{
	window["iw"] = {};
}

window["iw"].initCustomCheckboxes = initCustomCheckboxes;
window["iw"].initCustomCheckbox = initCustomCheckbox;
